<template>
  <div class="app-container" ref="pie" style="width: 100%; height: 100%"></div>
</template>

<script>
import * as echart from "echarts";

export default {
  name: "ec-pie",
  props: {
    type: {
      required: true,
      type: String,
      default: "细环",
    },
    data: {
      required: true,
      type: Array,
    },
    color: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    unit: {
      default: "",
    },
  },
  watch: {
    data(newVal) {
      this.data.forEach((e) => {
        e.rate = (e.rate * 1).toFixed(2);
      });
      if (Array.isArray(newVal) && newVal.length > 0) {
        if (this.type == "细环") {
          this.initLittlePie();
        } else if (this.type == "小环比") {
          this.initSmallPieRate();
        } else if (this.type == "环比") {
          this.initPieRate();
        } else if (this.type == "宽环比") {
          this.initWidePieRate();
        } else if (this.type == "大环") {
          this.initBigPie();
        } else if (this.type == "标准环") {
          this.initNormalPie();
        } else if (this.type == "简略环") {
          this.initBriefPie();
        } else if (this.type == "大环无lable") {
          this.initBigPienolable();
        } else if (this.type == "细环无led") {
          this.initLittlePieNoled();
        }
      }
    },
  },
  data() {
    return {
      echartImpl: null,
    };
  },
  mounted() {
    this.data.forEach((e) => {
      e.rate = (e.rate * 1).toFixed(2);
    });
    this.echartImpl = echart.init(this.$refs.pie);
    if (this.type == "细环") {
      this.initLittlePie();
      this.echartImpl.on("click", this.clickCallback);
    } else if (this.type == "小环比") {
      this.initSmallPieRate();
    } else if (this.type == "环比") {
      this.initPieRate();
    } else if (this.type == "宽环比") {
      this.initWidePieRate();
    } else if (this.type == "大环") {
      this.initBigPie();
    } else if (this.type == "标准环") {
      this.initNormalPie();
    } else if (this.type == "简略环") {
      this.initBriefPie();
    } else if (this.type == "大环无lable") {
      this.initBigPienolable();
    } else if (this.type == "细环无led") {
      this.initLittlePieNoled();
    }
    window.addEventListener("resize", this.resizeEchart);
  },
  activated() {
    this.resizeEchart();
  },

  beforeDestroy() {
    this.echartImpl = null;
    window.removeEventListener("resize", this.resizeEchart);
  },
  methods: {
    myEchartsFontSize(value, n) {
      let screenWidth = document.body.clientWidth;
      const result = value * (screenWidth / 1920) * n;
      return result;
    },
    resizeEchart() {
      this.echartImpl.resize();
    },
    clickCallback(param) {
      console.log(param, "param");
    },
    initLittlePie() {
      let option = {
        tooltip: {
          trigger: "item",
          show: false,
        },
        legend: {
          type: "scroll",
          top: "center",
          right: "1%",
          orient: "vertical",
          textStyle: {
            color: "#fff",
            fontSize: this.myEchartsFontSize(14, 1),
          },
        },
        color: [
          "rgba(255, 173, 0, 1)",
          "rgba(0, 247, 255, 1)",
          "rgba(190, 190, 190, 1)",
          "rgba(254, 73, 73, 1)",
          "rgba(111, 90, 255, 1)",
          "#00ff0f",
          "#ff00f0",
          "#fff000",
        ],
        series: [
          {
            name: "",
            type: "pie",
            left: "-25%",
            top: "0%",
            radius: ["40%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: "rgba(22, 41, 73, 1)",
              borderWidth: 3,
            },
            label: {
              show: true,
              position: "outside",
              color: "#fff",
              formatter: "{b}",
              textStyle: {
                fontSize: this.myEchartsFontSize(12, 1),
              },

              // formatter: "{c}\n{b}"
            },
            labelLine: {
              show: true,
            },
            data: this.data,
          },
        ],
      };
      this.echartImpl.setOption(option);
    },
    initLittlePieNoled() {
      let option = {
        tooltip: {
          trigger: "item",
          show: true,
          backgroundColor: "rgba(50,50,180,0.45)", // 修改背景颜色
          borderColor: "#fff", // 修改字体颜色
          textStyle: {
            color: "#fff",
          },
        },
        legend: {
          show: false,
          type: "scroll",
          top: "center",
          right: "1%",
          orient: "vertical",
          textStyle: {
            color: "#fff",
            fontSize: this.myEchartsFontSize(14, 1),
          },
        },
        color: [
          "rgba(255, 173, 0, 1)",
          "rgba(0, 247, 255, 1)",
          "rgba(190, 190, 190, 1)",
          "rgba(254, 73, 73, 1)",
          "rgba(111, 90, 255, 1)",
          "#00ff0f",
          "#ff00f0",
          "#fff000",
        ],
        series: [
          {
            name: "",
            type: "pie",
            left: "0%",
            top: "0%",
            radius: ["40%", "55%"],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: "rgba(22, 41, 73, 1)",
              borderWidth: 0,
            },
            label: {
              show: true,
              position: "outside",
              alignTo: "center",
              // margin:10,
              color: "#fff",
              // formatter: "{c}\n{b}"
              formatter: "{b}",
              textStyle: {
                fontSize: this.myEchartsFontSize(12, 1),
              },
              // formatter(v) {
              // 	// console.log(v.name,v.value)
              // 	let text = v.name
              // 	if(text.length <= 3)
              // 	{
              // 		var s=v.value +`\n`+v.name;
              // 			return s;
              // 	}else if(text.length > 3){
              // 		var s=  v.value+`\n`+`${text.slice(0,3)}\n${text.slice(3)}`;
              // 			return s;
              // 	}
              // },
            },
            labelLine: {
              show: true,
            },
            data: this.data,
          },
        ],
      };
      this.echartImpl.setOption(option);
      this.echartImpl.resize();
    },
    initNormalPie() {
      let option = {
        title: {
          text: this.title,
          top: "48%",
          left: "29%",
          textStyle: {
            color: "#000",
            fontSize: this.myEchartsFontSize(18, 1),
          },
        },
        tooltip: {
          trigger: "item",
          show: true,
        },
        legend: {
          type: "scroll",
          top: "center",
          right: "2%",
          orient: "vertical",
          textStyle: {
            color: "#000",
            fontSize: this.myEchartsFontSize(14, 1),
          },
        },
        color: ["#FF6060", "#00DBB6", "#008EFF", "#FFC645", "#BF7BFF"],
        series: [
          {
            name: "",
            type: "pie",
            left: "-25%",
            top: "0%",
            radius: ["40%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: "#FAFCFF",
              borderWidth: 3,
            },
            label: {
              show: true,
              position: "outside",
              fontSize: this.myEchartsFontSize(12, 1),
              color: "#000",
              formatter: "{c}\n{b}",
              textStyle: {
                fontSize: this.myEchartsFontSize(12, 1),
              },
            },
            labelLine: {
              show: true,
            },
            data: this.data,
          },
        ],
      };
      this.echartImpl.setOption(option);
    },
    initBriefPie() {
      let option = {
        title: {
          text: this.title,
          top: "center",
          left: "center",
          textStyle: {
            color: "#000",
            fontSize: this.myEchartsFontSize(18, 1),
          },
        },
        tooltip: {
          trigger: "item",
          show: true,
        },
        legend: {
          show: false,
          type: "scroll",
          top: "center",
          right: "4%",
          orient: "vertical",
          textStyle: {
            color: "#000",
            fontSize: this.myEchartsFontSize(14, 1),
          },
        },
        color: ["#FF6060", "#00DBB6", "#008EFF", "#FFC645", "#BF7BFF"],
        series: [
          {
            name: "",
            type: "pie",
            left: "center",
            top: "center",
            radius: ["90%", "110%"],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: "#FAFCFF",
              borderWidth: 3,
            },
            label: {
              show: true,
              position: "outside",
              fontSize: this.myEchartsFontSize(14, 1),
              color: "#000",
              formatter: "{c}\n{b}",
              textStyle: {
                fontSize: this.myEchartsFontSize(12, 1),
              },
            },
            labelLine: {
              show: true,
            },
            data: this.data,
          },
        ],
      };
      this.echartImpl.setOption(option);
    },
    initSmallPieRate() {
      let option = {
        tooltip: {
          trigger: "item",
          show: false,
        },
        title: {
          text: this.unit,
          textStyle: {
            color: "#ccc",
            fontSize: this.myEchartsFontSize(14, 1),
          },
        },
        legend: {
          type: "scroll",
          top: "center",
          right: "1%",
          orient: "vertical",
          formatter: (name) => {
            let rate;
            this.data.filter((item) => {
              if (item.name == name) {
                rate = item.rate;
              }
              return true;
            });
            if (rate < 0) {
              return `${name}`;
            } else if (rate == 0) {
              return `${name}`;
            } else {
              return `${name}`;
            }
          },
          textStyle: {
            color: "#fff",
            rich: {
              red: {
                color: "#FF581E",
                fontWeight: "bold",
                fontSize: this.myEchartsFontSize(12, 1),
              },
              grey: {
                color: "#bebebe",
                fontWeight: "bold",
                fontSize: this.myEchartsFontSize(12, 1),
              },
              green: {
                color: "#00FF55",
                fontWeight: "bolder",
                fontSize: this.myEchartsFontSize(12, 1),
              },
            },
          },
          icon: "circle",
        },
        color: [
          "rgba(255, 173, 0, 1)",
          "rgba(0, 247, 255, 1)",
          "rgba(190, 190, 190, 1)",
          "rgba(254, 73, 73, 1)",
          "rgba(111, 90, 255, 1)",
          "#00ff0f",
          "#ff00f0",
          "#fff000",
        ],
        series: [
          {
            name: "",
            type: "pie",
            left: "-45%",
            top: "0%",
            startAngle: 15,
            radius: ["23%", "38%"],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: "rgba(20,49,100,0.8)",
              borderWidth: 2,
            },
            label: {
              show: true,
              position: "outside",
              color: "#fff",
              // formatter: "{c}\n{b}"
              formatter: "{b}",
              textStyle: {
                fontSize: this.myEchartsFontSize(12, 1),
              },
              formatter: function (params) {
                var text = params.name;
                var length = text.length;
                var maxLineLength = 4; // 每行最多显示的字符数
                var lineCount = Math.ceil(length / maxLineLength); // 计算需要几行
                var lines = [];
                for (var i = 0; i < lineCount; i++) {
                  var line = text.substr(i * maxLineLength, maxLineLength);
                  lines.push(line);
                }
                return lines.join("\n");
              },
            },
            labelLine: {
              show: true,
            },
            data: this.data,
          },
        ],
      };
      this.echartImpl.setOption(option);
    },
    initPieRate() {
      let option = {
        tooltip: {
          trigger: "item",
          show: false,
        },
        title: {
          text: this.unit,
          left: "2.5%",
          textStyle: {
            color: "#ccc",
            fontSize: this.myEchartsFontSize(14, 1),
          },
        },
        legend: {
          type: "scroll",
          top: "center",
          right: "1%",
          orient: "vertical",
          //图例标记的图形高度
          itemHeight: 6,
          //图例标记的图形宽度
          itemWidth: 6,
          formatter: (name) => {
            let rate;
            this.data.filter((item) => {
              if (item.name == name) {
                rate = item.rate;
              }
              return true;
            });
            if (rate < 0) {
              return `${name}`;
            } else if (rate == 0) {
              return `${name}`;
            } else {
              return `${name}`;
            }
          },
          textStyle: {
            color: "#fff",
            fontSize: this.myEchartsFontSize(14, 1),
            rich: {
              red: {
                color: "#FF581E",
                fontWeight: "bold",
                fontSize: this.myEchartsFontSize(12, 1),
              },
              grey: {
                color: "#bebebe",
                fontWeight: "bold",
                fontSize: this.myEchartsFontSize(12, 1),
              },
              green: {
                color: "#00FF55",
                fontWeight: "bolder",
                fontSize: this.myEchartsFontSize(12, 1),
              },
            },
          },
          icon: "circle",
        },
        color: [
          "rgba(255, 173, 0, 1)",
          "rgba(0, 247, 255, 1)",
          "rgba(190, 190, 190, 1)",
          "rgba(254, 73, 73, 1)",
          "rgba(111, 90, 255, 1)",
          "#00ff0f",
          "#ff00f0",
          "#fff000",
        ],
        series: [
          {
            name: "",
            type: "pie",
            left: "-31%",
            top: "0%",
            startAngle: 45,
            radius: ["35%", "52%"],
            // avoidLabelOverlap: false,
            avoidLabelOverlap: true,
            // roundCap: true,
            labelLine: {
              normal: {
                show: true,
                length: 10,
                length2: 10,
                lineStyle: {
                  width: 1,
                  type: "solid",
                },
              },
            },
            label: {
              normal: {
                formatter: (params) => {
                  return `{b|${params.value}}\n{hr|}\n{d|${params.name}}`;
                },
                textStyle: {
                  fontSize: this.myEchartsFontSize(14, 1),
                },
                position: "outer",
                alignTo: "labelLine",
                distanceToLabelLine: 0,
                rich: {
                  b: {
                    fontSize: this.myEchartsFontSize(12, 1),
                    color: "inherit",
                    align: "center",
                    lineHeight: 20,
                  },
                  d: {
                    fontSize: this.myEchartsFontSize(12, 1),
                    color: "#FFF",
                    align: "center",
                    lineHeight: 20,
                    padding: [4, 0, 0, 0],
                  },
                  hr: {
                    borderColor: "inherit",
                    width: "100%",
                    borderWidth: 1,
                    borderType: "solid",
                    height: 0,
                  },
                },
              },
            },
            data: this.data,
          },
        ],
      };
      this.echartImpl.setOption(option);
    },
    initWidePieRate() {
      let option = {
        tooltip: {
          trigger: "item",
          show: false,
        },
        legend: {
          type: "scroll",
          top: "center",
          right: "10%",
          orient: "vertical",
          formatter: (name) => {
            let rate;
            let index;
            let colorPad = ["yellow", "red", "purple", "blue"];

            this.data.filter((item, i) => {
              if (item.name == name) {
                rate = item.rate;
                index = i;
              }
              return true;
            });
            return `${name} {${colorPad[index]}|${rate}}`;
          },
          textStyle: {
            color: "#fff",

            rich: {
              yellow: {
                color: "rgba(255, 173, 0, 1)",
                fontWeight: "bold",
                fontSize: this.myEchartsFontSize(14, 1),
              },
              red: {
                color: "rgba(255, 55, 55, 1)",
                fontWeight: "bold",
                fontSize: this.myEchartsFontSize(14, 1),
              },
              purple: {
                color: "rgba(111, 90, 255, 1)",
                fontWeight: "bolder",
                fontSize: this.myEchartsFontSize(14, 1),
              },
              blue: {
                color: "rgba(0, 250, 255, 1)",
                fontWeight: "bolder",
                fontSize: this.myEchartsFontSize(14, 1),
              },
            },
          },
          icon: "circle",
        },
        color: this.color || [
          "rgba(255, 173, 0, 1)",
          "rgba(0, 247, 255, 1)",
          "rgba(190, 190, 190, 1)",
          "rgba(254, 73, 73, 1)",
          "rgba(111, 90, 255, 1)",
          "#00ff0f",
          "#ff00f0",
          "#fff000",
        ],
        series: [
          {
            name: "",
            type: "pie",
            left: "-55%",
            top: "0%",
            startAngle: 45,
            radius: ["25%", "45%"],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: "rgba(20,49,100,0.8)",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "outside",
              color: "#fff",
              formatter: "{c}\n{b}",
              textStyle: {
                fontSize: this.myEchartsFontSize(14, 1),
              },
            },
            labelLine: {
              show: false,
            },
            data: this.data,
          },
        ],
      };
      this.echartImpl.setOption(option);
    },
    initBigPie() {
      let option = {
        tooltip: {
          trigger: "item",
          show: false,
        },
        legend: {
          show: false,
          type: "scroll",
          top: "center",
          right: "10%",
          orient: "vertical",
          formatter: (name) => {
            let rate;
            let index;
            let colorPad = ["yellow", "red", "purple", "blue"];

            this.data.filter((item, i) => {
              if (item.name == name) {
                rate = item.rate;
                index = i;
              }
              return true;
            });
            return `${name} {${colorPad[index]}|${rate}}`;
          },
          textStyle: {
            color: "#fff",

            rich: {
              yellow: {
                color: "rgba(255, 173, 0, 1)",
                fontWeight: "bold",
                fontSize: this.myEchartsFontSize(14, 1),
              },
              red: {
                color: "rgba(255, 55, 55, 1)",
                fontWeight: "bold",
                fontSize: this.myEchartsFontSize(14, 1),
              },
              purple: {
                color: "rgba(111, 90, 255, 1)",
                fontWeight: "bolder",
                fontSize: this.myEchartsFontSize(14, 1),
              },
              blue: {
                color: "rgba(0, 250, 255, 1)",
                fontWeight: "bolder",
                fontSize: this.myEchartsFontSize(14, 1),
              },
            },
          },
          icon: "circle",
        },
        color: this.color || [
          "rgba(255, 173, 0, 1)",
          "rgba(0, 247, 255, 1)",
          "rgba(190, 190, 190, 1)",
          "rgba(254, 73, 73, 1)",
          "rgba(111, 90, 255, 1)",
          "#00ff0f",
          "#ff00f0",
          "#fff000",
        ],
        series: [
          {
            name: "",
            type: "pie",
            radius: "65px",
            center: ["25%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              borderColor: "rgba(20,49,100,0.8)",
              borderWidth: 0,
            },
            label: {
              show: true,
              position: "inside",
              color: "#fff",
              formatter: "{d}%\n{b}",
              textStyle: {
                fontSize: this.myEchartsFontSize(14, 1),
              },
            },
            labelLine: {
              show: false,
            },
            data: this.data,
          },
        ],
      };
      this.echartImpl.setOption(option);
    },
    initBigPienolable() {
      let option = {
        tooltip: {
          trigger: "item",
          show: true,
          backgroundColor: "rgba(50,50,180,0.45)", // 修改背景颜色
          borderColor: "#fff", // 修改字体颜色
          textStyle: {
            color: "#fff",
          },
        },
        legend: {
          show: true,
          // type: 'scroll',
          top: "10%",
          right: "2%",
          left: "55%",
          bottom: "10%",
          orient: "horizontal",
          //       formatter: (name) => {
          //         let rate
          //         let index
          //         let colorPad = ['yellow', 'red', 'purple', 'blue']

          //         this.data.filter((item, i) => {
          //           if (item.name == name) {
          //             rate = item.rate
          //             index = i
          //           }
          //           return true
          //         })
          //         return `${name} {${colorPad[index]}|${rate}}`
          //       },
          textStyle: {
            color: "#fff",
            fontSize: this.myEchartsFontSize(14, 1),
            // rich: {
            //   yellow: {
            //     color: 'rgba(255, 173, 0, 1)',
            //     fontWeight: 'bold',
            //     fontSize: 10,
            //   }, red: {
            //     color: 'rgba(255, 55, 55, 1)',
            //     fontWeight: 'bold',
            //     fontSize: 10,
            //   },
            //   purple: {
            //     color: 'rgba(111, 90, 255, 1)',
            //     fontWeight: 'bolder',
            //     fontSize: 10,
            //   },
            //   blue: {
            //     color: 'rgba(0, 250, 255, 1)',
            //     fontWeight: 'bolder',
            //     fontSize: 10,
            //   }
            // }
          },
          icon: "circle",
        },
        color: this.color || [
          "rgba(255, 173, 0, 1)",
          "rgba(0, 247, 255, 1)",
          "rgba(190, 190, 190, 1)",
          "rgba(254, 73, 73, 1)",
          "rgba(111, 90, 255, 1)",
          "#00ff0f",
          "#ff00f0",
          "#fff000",
        ],
        series: [
          {
            name: "",
            type: "pie",
            radius: "60px",
            center: ["25%", "50%"],
            avoidLabelOverlap: true,
            itemStyle: {
              // borderRadius: 10,
              borderColor: "rgba(20,49,100,0.8)",
              borderWidth: 0,
            },
            label: {
              show: false,
              position: "inside",
              color: "#fff",
              formatter: "{d}%\n{b}",
              textStyle: {
                fontSize: this.myEchartsFontSize(14, 1),
              },
            },
            labelLine: {
              show: false,
            },
            data: this.data,
          },
        ],
      };
      this.echartImpl.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.app-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

::v-deep.echarts {
  width: 100%;
  height: 100%;

  div {
    &:nth-child(1) {
      width: 100% !important;
      height: 100% !important;

      canvas {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
}
</style>
